/* Filtrous - clearance offer placement on the PDP.

   2026-08-04 (original): the app (assets/filtrous-v3.js) rendered ONE line
   under the buy row: "Buy One, Get One Free - just add 2 to cart. No code
   needed." It sat after the decision point, sharing weight and colour with the
   Net-30 note beneath it, so it read as fine print and went unread. This
   splits it into two placements:
     1. the offer name - thin teal, ABOVE "Part number" (top of buy box), so
        the offer is seen before the price and quantity are considered.
     2. the condition - teal, directly UNDER the quantity counter /
        Add-to-cart row, where the condition is actionable.

   2026-09-10: two offers now exist. Products tagged `Buy3Get2` are on Buy
   Three, Get Two Free; products tagged `clearance` stay on BOGO. PTF-GS-0010
   and PTF-LS-0010 were moved off `clearance` onto `Buy3Get2`.

   The discount function reads those tags. This script cannot: the V3 PDP is
   rendered client-side from a baked index and puts no tags in the DOM, so the
   only product identity available here is the SKU in the buy box (.part).
   Hence SKUS_3F2 below, which must mirror whatever carries the `Buy3Get2` tag
   in Shopify. If they drift, the page promises an offer the cart does not give.

   Reading the SKU also solves two problems the old anchor could not:

     - PTF-LS-0010 is still in the BOGO_SKUS list baked into minified
       filtrous-v3.js, so the app still emits a BOGO `.pdp-bogo` line for it.
       The SKU test runs first and overrides that line rather than dressing it
       up. The minified bundle is not editable by hand.
     - PTF-GS-0010 is NOT in BOGO_SKUS, so the app emits nothing for it and
       there is no `.pdp-bogo` to anchor to. The buy box itself is the anchor.

   Revert: remove the Clearance BOGO offer section from templates/product.json.
   The original .pdp-bogo line returns on its own.
*/
(function () {
  if (window.__fbogoInit) return;
  window.__fbogoInit = true;

  var DTEAL = '#0d7d68'; /* --dteal */

  var CFG = window.FBOGO_CONFIG || {};
  var T_BADGE = CFG.badge || 'Buy One, Get One Free';
  var T_COND = CFG.condition || 'Applies only when 2 items are in your cart.';
  var T_BADGE_3F2 = CFG.badge3f2 || 'Buy Three, Get Two Free';
  var T_COND_3F2 =
    CFG.condition3f2 || 'Applies only when 5 items are in your cart.';

  var SKUS_3F2 = {};
  String(CFG.skus3f2 || 'PTF-GS-0010,PTF-LS-0010')
    .split(',')
    .forEach(function (s) {
      s = s.trim().toUpperCase();
      if (s) SKUS_3F2[s] = 1;
    });

  function line(cls, text, style) {
    var d = document.createElement('div');
    d.className = cls;
    d.setAttribute('style', style);
    d.textContent = text;
    return d;
  }

  function badge(text) {
    return line(
      'pdp-bogo-badge',
      text,
      'margin:0 0 6px;font-size:13px;font-weight:300;line-height:1.3;color:' +
        DTEAL + ';'
    );
  }

  function condition(text) {
    return line(
      'pdp-bogo-cond',
      text,
      'margin:8px 0 0;font-size:13px;font-weight:400;line-height:1.4;color:' +
        DTEAL + ';'
    );
  }

  function drop(el) {
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }

  /* Which offer this buy box should advertise, or null for none. */
  function offerFor(buy, hasLegacyLine) {
    var partEl = buy.querySelector('.part');
    var sku = partEl ? partEl.textContent.trim().toUpperCase() : '';

    if (sku && SKUS_3F2[sku]) {
      return { key: sku, badge: T_BADGE_3F2, cond: T_COND_3F2 };
    }
    /* BOGO still relies on the app having decided this SKU qualifies. */
    if (hasLegacyLine) return { key: 'bogo', badge: T_BADGE, cond: T_COND };
    return null;
  }

  function apply() {
    /* The buy box is the parent of "Part number". On a 3-for-2 SKU that is the
       only anchor we get, because the app emits no .pdp-bogo line for it. */
    var label = document.querySelector('#fv3-app .partlabel');
    if (!label) return;

    var buy = label.parentNode;
    if (!buy) return;

    var legacy = buy.querySelector('.pdp-bogo');
    var offer = offerFor(buy, !!legacy);

    /* Always retire the app's own line; ours replaces it. */
    drop(legacy);

    var existing = buy.querySelector('.pdp-bogo-badge');

    if (!offer) {
      /* SPA navigation landed on a product with no offer - clear any leftovers. */
      drop(existing);
      drop(buy.querySelector('.pdp-bogo-cond'));
      return;
    }

    /* Already placed for this same product on this render. */
    if (existing && existing.getAttribute('data-offer') === offer.key) return;

    drop(existing);
    drop(buy.querySelector('.pdp-bogo-cond'));

    var b = badge(offer.badge);
    b.setAttribute('data-offer', offer.key);
    buy.insertBefore(b, label);

    var row = buy.querySelector('.fv3-buyrow');
    var c = condition(offer.cond);
    if (row && row.nextSibling) buy.insertBefore(c, row.nextSibling);
    else if (row) buy.appendChild(c);
    else buy.appendChild(c);
  }

  function boot() {
    apply();
    var mount = document.getElementById('fv3-app') || document.body;
    new MutationObserver(apply).observe(mount, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
